import React from 'react';
import { connect } from 'react-redux';
import SignUpPage from '../components/SignUpPage';
import { SignUpSelectors } from '../../../Redux/modules/signup/selectors';
import { SignUpActions } from '../../../Redux/modules/signup/actions';

const mapStateToProps = (state) => {
  return {
    fields: SignUpSelectors.signUpFieldsSelector(state),
    isLoading: SignUpSelectors.signUpLoadingSelector(state),
    product: SignUpSelectors.signUpProductSelector(state),
    prepopulatedFields: SignUpSelectors.signUpPrePopulatedFieldsSelector(state),
  };
};
const mapDispatchToProps = {
  submitSignUpForm: SignUpActions.submitSignUp,
  updateFields: SignUpActions.updateFields,
};

export default connect(mapStateToProps, mapDispatchToProps)(SignUpPage);
